import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from "@mui/material";
import { TripCardWrapper } from "./trip-card.style";
function TripCardSkeleton(_a) {
    var _b = _a.cards, cards = _b === void 0 ? 3 : _b;
    return (_jsx("div", { style: { display: "flex", gap: "1rem" }, children: Array.from({ length: cards }).map(function (_, index) { return (_jsx(TripCardWrapper, { children: _jsx(Skeleton, { animation: "wave", variant: "rectangular", height: "100%", style: { marginBottom: 10 }, width: "100%" }, index) }, index)); }) }));
}
export default TripCardSkeleton;
